// Total time moving from X_MIN to X_MAX in carousel
export const SLIDE_TIME = 180;
// 'Beginning' of the slide.  Start this many pixels left of screen
export const X_OFFSET = 70;
export const Y_OFFSET = 80;
// Total distance between X_MIN and X_MAX
export const X_TOTAL_DISTANCE = 2800;
export const X_MAX = X_TOTAL_DISTANCE - X_OFFSET;
export const X_MIN = -X_OFFSET;
// How much the icons 'bounce' up and down
export const BOUNCE_HEIGHT = 25;
// Time to move from highest to lowest bounce point (s)
export const BOUNCE_TIME = 4;
// Time to go from 0 opactity fo 1 opacity on first load
export const APPEAR_TIME = 1.5;
